// ============================================================
// MOCK DATA for Bella Edifices clone (frontend-only teaser)
// This will later be replaced by real backend API data.
// ============================================================

export const HERO_VIDEO_ID = "KT2uskVDnkY"; // Playa del Carmen / Riviera Maya drone footage
export const HERO_POSTER =
  "https://images.unsplash.com/photo-1541417904950-b855846fe074";

export const SERVICES = [
  { icon: "Landmark", label: "Financement" },
  { icon: "PlaneTakeoff", label: "Assurance voyage" },
  { icon: "Calculator", label: "Stratégie fiscale" },
  { icon: "Languages", label: "Traduction EN / FR / ESP" },
  { icon: "Wallet", label: "Compte bancaire" },
  { icon: "LineChart", label: "Conseils financiers" },
  { icon: "Crown", label: "Planification de visite VIP" },
  { icon: "BadgeCheck", label: "Résidence, citoyenneté, visa" },
];

// Property statuses used across the app + admin
export const PROPERTY_STATUSES = [
  { value: "disponible", label: "Disponible", color: "emerald" },
  { value: "reserve", label: "Réservé", color: "amber" },
  { value: "vendu", label: "Vendu", color: "rose" },
  { value: "prevente", label: "Prévente", color: "sky" },
];

export const PROPERTY_TYPES = [
  { value: "revente", label: "Revente" },
  { value: "prevente", label: "Prévente" },
];

export const PROPERTIES = [
  {
    id: "p1",
    title: "IT Beach — 3 Chambres",
    location: "Playa del Carmen, Quintana Roo",
    type: "revente",
    status: "disponible",
    price: 599000,
    currency: "USD",
    bedrooms: 3,
    bathrooms: 2,
    area: 142,
    image: "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff",
    gallery: [
      "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff",
      "https://images.unsplash.com/photo-1543489822-c49534f3271f",
      "https://images.unsplash.com/photo-1613977257592-4871e5fcd7c4",
    ],
    description:
      "Condo en bord de mer prêt à générer des revenus locatifs. Piscine à débordement, finitions haut de gamme et accès direct à la plage.",
    features: ["Piscine à débordement", "Vue mer", "Gym", "Rooftop", "Sécurité 24/7"],
  },
  {
    id: "p2",
    title: "Singular Joy — 1 Chambre",
    location: "Playa del Carmen, Quintana Roo",
    type: "prevente",
    status: "prevente",
    price: 189000,
    currency: "USD",
    bedrooms: 1,
    bathrooms: 1,
    area: 58,
    image: "https://images.unsplash.com/photo-1613977257592-4871e5fcd7c4",
    gallery: [
      "https://images.unsplash.com/photo-1613977257592-4871e5fcd7c4",
      "https://images.pexels.com/photos/1488267/pexels-photo-1488267.png",
    ],
    description:
      "Projet en prévente à fort potentiel de valorisation, livraison 2026. Idéal pour un premier investissement au Mexique.",
    features: ["Prévente", "Rooftop", "Coworking", "Piscine", "Plan de paiement"],
  },
  {
    id: "p3",
    title: "Asoleadero Residences",
    location: "Tulum, Quintana Roo",
    type: "prevente",
    status: "prevente",
    price: 275000,
    currency: "USD",
    bedrooms: 2,
    bathrooms: 2,
    area: 96,
    image: "https://images.pexels.com/photos/2476632/pexels-photo-2476632.jpeg",
    gallery: [
      "https://images.pexels.com/photos/2476632/pexels-photo-2476632.jpeg",
      "https://images.unsplash.com/photo-1543489822-c49534f3271f",
    ],
    description:
      "Résidence entourée de nature à Tulum, design biophilique et amenities premium. Un placement dans l'une des zones les plus prisées.",
    features: ["Nature", "Piscine", "Spa", "Wellness", "Cenote"],
  },
  {
    id: "p4",
    title: "Bahía Infinity Villa",
    location: "Puerto Aventuras, Quintana Roo",
    type: "revente",
    status: "reserve",
    price: 845000,
    currency: "USD",
    bedrooms: 4,
    bathrooms: 4,
    area: 320,
    image: "https://images.unsplash.com/photo-1543489822-c49534f3271f",
    gallery: [
      "https://images.unsplash.com/photo-1543489822-c49534f3271f",
      "https://images.pexels.com/photos/1488267/pexels-photo-1488267.png",
    ],
    description:
      "Villa d'exception avec piscine à débordement sur la baie. Revente clé en main avec locataires en place.",
    features: ["Vue baie", "Marina", "Piscine privée", "Jardin", "Garage"],
  },
  {
    id: "p5",
    title: "Palma Residences — 2 Chambres",
    location: "Playa del Carmen, Quintana Roo",
    type: "revente",
    status: "vendu",
    price: 320000,
    currency: "USD",
    bedrooms: 2,
    bathrooms: 2,
    area: 88,
    image: "https://images.pexels.com/photos/1488267/pexels-photo-1488267.png",
    gallery: [
      "https://images.pexels.com/photos/1488267/pexels-photo-1488267.png",
      "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff",
    ],
    description:
      "Appartement au cœur de la 5ème avenue, rendement locatif prouvé. Vendu — nous avons des unités similaires disponibles.",
    features: ["Centre-ville", "Rooftop", "Airbnb friendly", "Piscine"],
  },
  {
    id: "p6",
    title: "Ocean Breeze Penthouse",
    location: "Playa del Carmen, Quintana Roo",
    type: "prevente",
    status: "prevente",
    price: 460000,
    currency: "USD",
    bedrooms: 3,
    bathrooms: 3,
    area: 165,
    image: "https://images.unsplash.com/photo-1772146775497-1f3034d3136c",
    gallery: [
      "https://images.unsplash.com/photo-1772146775497-1f3034d3136c",
      "https://images.unsplash.com/photo-1773802467099-1433a349ef1a",
    ],
    description:
      "Penthouse en prévente avec terrasse panoramique et jacuzzi privé. Vue imprenable sur la mer des Caraïbes.",
    features: ["Penthouse", "Jacuzzi", "Terrasse", "Vue mer", "Prévente"],
  },
];

export const FORMATIONS = [
  {
    id: "f1",
    title: "Investir au Mexique — Les fondamentaux",
    level: "Débutant",
    duration: "4 semaines",
    price: 0,
    format: "En ligne",
    image:
      "https://images.unsplash.com/photo-1762968269894-1d7e1ce8894e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxyZWFsJTIwZXN0YXRlJTIwc2VtaW5hcnxlbnwwfHx8fDE3ODc3NjYyODd8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Comprenez le cadre légal, fiscal et financier pour acheter en toute sérénité au Mexique.",
    lessons: 12,
  },
  {
    id: "f2",
    title: "Financement immobilier international",
    level: "Intermédiaire",
    duration: "6 semaines",
    price: 299,
    format: "Hybride",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG5ldHdvcmtpbmd8ZW58MHx8fHwxNzg3NzY2Mjg3fDA&ixlib=rb-4.1.0&q=85",
    description:
      "Maîtrisez les montages financiers, l'effet de levier et les stratégies de financement transfrontalier.",
    lessons: 18,
  },
  {
    id: "f3",
    title: "Optimisation fiscale & résidence",
    level: "Avancé",
    duration: "8 semaines",
    price: 499,
    format: "En présentiel",
    image:
      "https://images.unsplash.com/photo-1675716921224-e087a0cca69a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG5ldHdvcmtpbmd8ZW58MHx8fHwxNzg3NzY2Mjg3fDA&ixlib=rb-4.1.0&q=85",
    description:
      "Stratégies fiscales avancées, structuration patrimoniale et parcours vers la résidence mexicaine.",
    lessons: 24,
  },
];

export const EVENTS = [
  {
    id: "e1",
    title: "Séminaire VIP — Riviera Maya",
    date: "2025-09-18",
    time: "18:00",
    location: "Montréal, QC",
    type: "Présentiel",
    seats: 40,
    image:
      "https://images.unsplash.com/photo-1675716921224-e087a0cca69a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG5ldHdvcmtpbmd8ZW58MHx8fHwxNzg3NzY2Mjg3fDA&ixlib=rb-4.1.0&q=85",
    description:
      "Une soirée exclusive pour découvrir les meilleures opportunités d'investissement au Mexique.",
  },
  {
    id: "e2",
    title: "Webinaire — Prévente & valorisation",
    date: "2025-08-05",
    time: "12:00",
    location: "En ligne (Zoom)",
    type: "En ligne",
    seats: 200,
    image:
      "https://images.pexels.com/photos/8761650/pexels-photo-8761650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Comment identifier les projets en prévente à fort potentiel de valorisation.",
  },
  {
    id: "e3",
    title: "Visite VIP sur place — Playa del Carmen",
    date: "2025-10-22",
    time: "09:00",
    location: "Playa del Carmen, MX",
    type: "Présentiel",
    seats: 15,
    image:
      "https://images.unsplash.com/photo-1505118380757-91f5f5632de0",
    description:
      "Tour privé des propriétés sélectionnées, rencontres avec les promoteurs et notaires.",
  },
];

export const STATS = [
  { value: "+120", label: "Propriétés accompagnées" },
  { value: "12", label: "Années d'expertise" },
  { value: "+800", label: "Investisseurs conseillés" },
  { value: "4", label: "Villes au Mexique" },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Marie-Claude L.",
    role: "Investisseuse, Québec",
    text: "Un accompagnement clé en main du financement jusqu'à la remise des clés. Je recommande sans hésiter.",
  },
  {
    id: "t2",
    name: "Julien R.",
    role: "Entrepreneur, Lyon",
    text: "Grâce à Bella Edifices, j'ai acheté en prévente à Tulum avec un plan de paiement clair et sécurisé.",
  },
  {
    id: "t3",
    name: "Sophie M.",
    role: "Retraitée, Montréal",
    text: "Leur équipe m'a guidée pour la résidence et la fiscalité. Un service humain et professionnel.",
  },
];

export const formatPrice = (price, currency = "USD", priceFrom = false) => {
  if (price === null || price === undefined || price === "") return "Prix sur demande";
  const cur = currency || "USD";
  const amount = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: cur,
    maximumFractionDigits: 0,
  }).format(price);
  return priceFrom ? `À partir de ${amount}` : amount;
};

// Bathrooms: show half values as "2,5"; hide when null
export const formatBath = (v) => {
  if (v === null || v === undefined || v === "") return null;
  return String(v).replace(".", ",");
};

// HOA / condo fees: number only, NO currency symbol
export const formatHoa = (v) => {
  if (v === null || v === undefined || v === "") return null;
  return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(v);
};

export const statusMeta = (value) =>
  PROPERTY_STATUSES.find((s) => s.value === value) || PROPERTY_STATUSES[0];
